class SwatchColor extends HTMLElement {
  constructor() {
    super();
    this.variantOption = this.getAttribute('variant-option');
    this.productId = this.getAttribute('product-id');
  }

  connectedCallback() {
    this.render();
  }

  render() {
    if (!this.variantOption) return;
    const swatches_split_1 = window.jouerSwatches.swatches_split_1[this.variantOption];
    const swatches_split_2 = window.jouerSwatches.swatches_split_2[this.variantOption];

    let chosenSwatch = null;

    if (swatches_split_1 && swatches_split_2) {
      const swatch1Matches = this.parseId(swatches_split_1?.specified_product) == this.productId;
      const swatch2Matches = this.parseId(swatches_split_2?.specified_product) == this.productId;

      if (this.productId == "7503194587313" && this.variantOption == "bare-rose") {
        console.log('swatch1Matches', swatch1Matches);
        console.log('swatch2Matches', swatch2Matches);
      }

      // Final logic: prefer swatch_2 if it matches; otherwise use swatch_1
      chosenSwatch = swatch2Matches ? swatches_split_2 : swatches_split_1;
    } else {
      // If only one exists, pick it; if none exists, null
      chosenSwatch = swatches_split_1 || swatches_split_2 || null;
    }

    if (chosenSwatch.secondary_color) {
      this.setAttribute('style', `background: linear-gradient(to right, ${chosenSwatch.color} 0% 50%, ${chosenSwatch.secondary_color} 50% 100%) !important`);
    } else {
      this.setAttribute('style', `background-color: ${chosenSwatch.color}`);
    }
  }

  parseId(id) {
    if (!id) return null;
    return id.split("Product/")[1];
  }
}

customElements.define('swatch-color', SwatchColor);